import React from "react";
import useComponents from "~/hooks/useAllComponents";
import { Carousel } from "@caesars-ui/core";
import cx from "components/src/utils/cx";
import ComponentLinks from "../ComponentLinks/ComponentLinks";

export const ComponentImages = ({ component, showScreenshots = true, showHeroImage = true, heroOnly = false }) => {
  // If heroOnly is true, only show hero image
  if (heroOnly) {
    showScreenshots = false;
    showHeroImage = true;
  }
    const _component =
    useComponents()
      .allAirtableComponents.edges.map((e) => e.node.data)
      .filter(
        (d) =>
          (d.Type === "Component" || d.Type === "Foundation") &&
          d.Name.toLowerCase() === component.display?.toLowerCase()
      )[0] || null;
    const heroImages = _component?.Hero_Image?.localFiles;
    const screenshots = _component?.Screenshots?.localFiles;
    const { publicURL = "", name = "" } = heroImages && heroImages.length ? heroImages[0] : { publicURL: null, name: null };

    const screenshotsMapped = screenshots?.length
      ? screenshots.map(({ publicURL, name }) => (
        <img
            src={publicURL}
            alt={name}
            className="h-[180px] border-1 border-solid border-fg-subtle rounded-2px"
        />
        ))
      : null;
    
      if (!showHeroImage && !showScreenshots) return null;

    // Ideal width 1280px
    return (
      <div className={cx({
        "mb-20": publicURL && showHeroImage || screenshotsMapped && showScreenshots
      }, "w-full flex flex-col")}>
        {publicURL && showHeroImage ? (
          <img
            src={publicURL}
            alt={name}
            className="w-full border-1 border-solid border-fg-subtle rounded-2px"
          />
        ) : null}
        {screenshotsMapped && showScreenshots ? (
            <Carousel slideWrapperClasses="bg-bg-layer-two w-full" className="mt-10 w-full">
            {screenshotsMapped}
            </Carousel>
        ) : null}
        <ComponentLinks 
          storybookUrl={_component?.Web === "Ready" ? "https://caesars-ui-storybook.pages.dev" : null}
          figmaUrl={_component?.Figma_Library || null}
          swiftUIUrl={_component?.iOS === "Ready" ? "https://github.com/caesars-digital/caesars-ui-ios" : null}
        />
      </div>
    );
};

export default ComponentImages;